import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  jsonLd?: object | object[];
}

/**
 * 每页设置独立 title / description，并注入 Schema.org JSON-LD 结构化数据。
 */
export default function usePageMeta({ title, description, jsonLd }: PageMeta) {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;

    // 移除旧的 JSON-LD 脚本（保留 index.html 里的 WebSite 全局脚本）
    document.querySelectorAll("script[data-page-jsonld]").forEach((s) => s.remove());

    if (jsonLd) {
      const list = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      list.forEach((schema) => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-page-jsonld", "true");
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
      });
    }
  }, [title, description, jsonLd]);
}